import React from 'react';
import {tr} from '../../translations';
import {drawerRoutes} from '../mainRoutes/drawerRoutes';
import {
  createDrawerNavigator,
  DrawerContentComponentProps,
} from '@react-navigation/drawer';
import SideMenu from '../../components/sideMenu';
import {I18nManager} from 'react-native';
import screens from '../../config/screens';
import useResponsiveDimensions from '../../utils/hooks/useResponsiveDimensions';

const customDrawer = (props: DrawerContentComponentProps) => {
  return <SideMenu {...props} />;
};

const HomeDrawer = () => {
  const {wdp, getByScreenSize} = useResponsiveDimensions();
  const DrawerNav = createDrawerNavigator();

  return (
    <DrawerNav.Navigator
      initialRouteName={screens.homeTabs}
      drawerContent={customDrawer}>
      {(drawerRoutes || []).map((screen, idx) => (
        //@ts-ignore
        <DrawerNav.Screen
          key={`screen${idx}`}
          options={{
            lazy: true,
            freezeOnBlur: true,
            swipeEnabled: true,
            drawerPosition: I18nManager.isRTL ? 'right' : 'left',
            headerShown: false,
            headerTransparent: true,
            drawerActiveTintColor: 'transparent',
            keyboardDismissMode: 'on-drag',
            drawerItemStyle: {flex: 1},
            drawerStyle: {
              width: wdp(getByScreenSize(100, 30)),
            },
            title: tr('drawer.' + `${screen.name}`),
            ...screen.options,
          }}
          name={screen.name}
          component={screen.component}
        />
      ))}
    </DrawerNav.Navigator>
  );
};
export default HomeDrawer;
